/**
 * 资源后缀相关
 */

/** 图片 */
const img_subfix_arr = [ "jpg", "jpeg" , "png", "gif" ];

/** 视频 */
const video_subfix_arr = [ "mp4" ];

/** flash */
const flash_subfix_arr = [ "swf" , "flv" ];

/** 文档 */
const document_subfix_arr = [ "doc", "docx" ];

/** 文档 */
const ppt_subfix_arr = [ "ppt", "pptx" ];

/** 文档 */
const pdf_subfix_arr = [ "pdf" ];

/** 游戏 */
const game_subfix_arr = [ "game" ];

/**
 * 以图片形式显示资源
 * @returns
 */
export function display_by_img(subfix) {
	if(is_arr_contains(img_subfix_arr, subfix)) {
		return true;
	}
	return false;
}

/**
 * 以video形式显示资源
 * @returns
 */
export function display_by_video(subfix) {
	if(is_arr_contains(video_subfix_arr, subfix)) {
		return true;
	}
	return false;
}

/**
 * 以flash形式显示资源
 * @returns
 */
export function display_by_flash(subfix) {
	if(is_arr_contains(flash_subfix_arr, subfix)) {
		return true;
	}
	return false;
}

/**
 * 以doc形式显示资源
 * @returns
 */
export function display_by_doc(subfix) {
	if(is_arr_contains(document_subfix_arr, subfix)) {
		return true;
	}
	return false;
}

/**
 * 以ppt形式显示资源
 * @returns
 */
export function display_by_ppt(subfix) {
	if(is_arr_contains(ppt_subfix_arr, subfix)) {
		return true;
	}
	return false;
}

/**
 * 以pdf形式显示资源
 * @returns
 */
export function display_by_pdf(subfix) {
	if(is_arr_contains(pdf_subfix_arr, subfix)) {
		return true;
	}
	return false;
}

/**
 * 以game形式显示资源
 * @returns
 */
export function display_by_game(subfix) {
	if(is_arr_contains(game_subfix_arr, subfix)) {
	return true;
	}
	return false;
}

/**
 * 是否以图片形式播放
 * @returns
 */
export function play_with_img(subfix) {
	if(is_arr_contains(img_subfix_arr, subfix)) {
		return true;
	}
	return false;
}

/**
 * 是否以视频形式播放
 * @returns
 */
export function play_with_video(subfix) {
	if(is_arr_contains(video_subfix_arr, subfix)) {
		return true;
	}
	return false;
}

/**
 * 是否以Flash形式播放
 * @returns
 */
export function play_with_flash(subfix) {
	if(is_arr_contains(flash_subfix_arr, subfix)) {
		return true;
	}
	return false;
}

/**
 * 是否以pdf形式播放
 * @returns
 */
export function play_with_pdf(subfix) {
	if(is_arr_contains(document_subfix_arr, subfix)
			|| is_arr_contains(ppt_subfix_arr, subfix)
			|| is_arr_contains(pdf_subfix_arr, subfix)) {
		return true;
	}
	return false;
}

/**
 * 以game形式显示资源
 * @returns
 */
export function play_with_game(subfix) {
  if(is_arr_contains(game_subfix_arr, subfix)) {
    return true;
  }
  return false;
}

/**
 * 根据subfix取得class
 * @returns
 */
export function get_class_by_subfix(subfix) {
	if(display_by_img(subfix)) {
		return "photo";
	}
	if(display_by_video(subfix)) {
		return "video";
	}
	if(display_by_flash(subfix)) {
		return "flash";
	}
	if(display_by_doc(subfix)) {
		return "word";
	}
	if(display_by_ppt(subfix)) {
		return "ppt";
	}
	if(display_by_pdf(subfix)) {
		return "pdf";
	}
	if(display_by_game(subfix)) {
		return "photo";
	}
	return "";
}

/**
 * 判断数组是否包含元素
 *
 * @param arr
 *            数组
 * @param ele
 *            元素
 * @returns true；包含；fasle：不包含
 */
function is_arr_contains(arr, ele) {

	if (ele == null || ele.length == '' || typeof (ele) == 'undefined') {
		return false;
	} else {
		ele = ele.toLowerCase();
	}

	if (arr == null || arr.length == 0) {
		return false;
	}

	for (var i = 0, j = arr.length; i < j; i++) {
		if (arr[i] == ele) {
			return true;
		}
	}

	return false;
}

export default {
	display_by_img(subfix){
		return display_by_img(subfix);
	},
	display_by_video(subfix){
		return display_by_video(subfix);
	},
	display_by_flash(subfix){
		return display_by_flash(subfix);
	},
	display_by_doc(subfix){
		return display_by_doc(subfix);
	},
	display_by_ppt(subfix){
		return display_by_ppt(subfix);
	},
	display_by_pdf(subfix){
		return display_by_pdf(subfix);
	},
	display_by_game(subfix){
	return display_by_game(subfix);
	},
	play_with_img(subfix){
		return play_with_img(subfix);
	},
	play_with_video(subfix){
		return play_with_video(subfix);
	},
	play_with_flash(subfix){
		return play_with_flash(subfix);
	},
	play_with_pdf(subfix){
		return play_with_pdf(subfix);
	},
	play_with_game(subfix){
	return play_with_game(subfix);
	},
	get_class_by_subfix(subfix){
		return get_class_by_subfix(subfix);
	}
}



// WEBPACK FOOTER //
// ./src/vuex/subfix.js